var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_603_545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.0341797,
    y: 0.0224609,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_603_545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_2",
    d: "M8.91909 23.3555C8.39701 23.3555 7.95231 23.1719 7.58501 22.8048C7.2179 22.4375 7.03434 21.9928 7.03434 21.4707V7.02213H5.86768V5.85547H10.5343V4.95801H17.5343V5.85547H22.201V7.02213H21.0343V21.4707C21.0343 22.0078 20.8545 22.4562 20.4948 22.8159C20.135 23.1756 19.6866 23.3555 19.1496 23.3555H8.91909ZM19.8677 7.02213H8.20101V21.4707C8.20101 21.6801 8.26829 21.8522 8.40284 21.987C8.53759 22.1215 8.70968 22.1888 8.91909 22.1888H19.1496C19.3293 22.1888 19.4939 22.114 19.6434 21.9645C19.7929 21.815 19.8677 21.6504 19.8677 21.4707V7.02213ZM11.4767 19.8555H12.6434V9.35547H11.4767V19.8555ZM15.4253 19.8555H16.592V9.35547H15.4253V19.8555Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/DeleteButton.8fdc0ad622b70dbde184018d1f47ed93.svg";
export { ForwardRef as ReactComponent };